import { MDBBtn, MDBInput } from "mdb-react-ui-kit";
import React, { useState } from "react";
import ImageContainer from "../ImageContainer";
import logo from "../../Assets/logoWhite.png";
import styles from "./style.module.scss";
import { createStructuredSelector } from "reselect";
import { selectProfile } from "../../Containers/Client/selector";
import { connect, useDispatch } from "react-redux";
import { addCommentAction } from "../../Containers/PostContainer/action";
import { toast } from "react-toastify";
import ProfilePicture from "../ProfilePicture";

function CommentForm({ parentId, creator, isFromPost, active, setActive }) {
	const dispatch = useDispatch();
	const initForm = {
		creator: creator.username,
		content: "",
	};
	const [formData, setFormData] = useState(initForm);
	const { comment } = formData;
	const onInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};
	const onSuccessSubmit = () => {
		toast.success("Comment successfully added!");
		setActive(!active);
		window.location.reload();
	};
	const onClickButton = () => {
		dispatch(addCommentAction(parentId, isFromPost, formData, onSuccessSubmit));
	};
	return (
		<div className={styles.container}>
			<div className={styles.componentContainer}>
				<ProfilePicture url={creator.profilePicture} isComment={true} />
			</div>
			<div className={styles.inputField}>
				<MDBInput
					label='Comment'
					autoFocus={true}
					placeholder='Say something...'
					name='content'
					value={comment}
					onChange={onInputChange}
					onKeyDown={(event) => {
						if (event.key === "Enter") onClickButton();
					}}
				/>
			</div>
			<MDBBtn className={styles.addComment} onClick={onClickButton}>
				<img src={logo} alt='logo' style={{ width: 12 }} />
			</MDBBtn>
		</div>
	);
}
const mapStateToProps = createStructuredSelector({
	creator: selectProfile,
});
export default connect(mapStateToProps)(CommentForm);
